import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function CreateEmployee() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [mobile, setMobile] = useState('');
    const [address, setAddress] = useState('');
    const [gender, setGender] = useState('');
    const [designation, setDesignation] = useState('');
    const [department, setDepartment] = useState('');
    const [employeeId, setEmployeeId] = useState('');
    const [grade, setGrade] = useState(1);
    const [selectedPages, setSelectedPages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [openSections, setOpenSections] = useState({});
    const navigate = useNavigate();

    // ✅ Same menu structure as Sidebar (only names & paths, no icons/actions)
    const menuSections = [
        {
            name: "Home",
            pages: [{ name: "Dashboard", path: "/dashboard" }]
        },
        {
            name: "Doctor Category",
            pages: [
                { name: "Create Category", path: "/create-category" },
                { name: "Get All Doctor Categories", path: "/doctorcategorylist" }
            ]
        },
        {
            name: "Companies",
            pages: [
                { name: "Add Company", path: "/company-register" },
                { name: "Company List", path: "/companylist" }
            ]
        },
        {
            name: "Diagnostics",
            pages: [
                { name: "Add Diagnostics", path: "/create-diagnostic" },
                { name: "Diagnostics List", path: "/diagnosticlist" },
                { name: "Diagnostics Bookings", path: "/diagnosticslist" },
                { name: "Appointment Booking", path: "/book-diagnostic" }
            ]
        },
        {
            name: "Doctors",
            pages: [
                { name: "Add Doctor", path: "/create-doctor" },
                { name: "Doctor List", path: "/doctorlist" },
                { name: "Appointment List", path: "/appintmentlist" },
                { name: "Book An Appointment", path: "/appintmentbooking" }
            ]
        },
        {
            name: "Requests",
            pages: [
                { name: "Doctor Accepted Request", path: "/doctoracceptedlist" },
                { name: "Doctor Rejected Requests", path: "/doctorrejectedlist" },
                { name: "Diagnostic Accepted Request", path: "/diagnosticsacceptedlist" },
                { name: "Diagnostic Rejected Requests", path: "/diagnosticsrejectedlist" }
            ]
        },
        {
            name: "HRA",
            pages: [
                { name: "Add HRA Category", path: "/create-hracat" },
                { name: "HRA CategoryList", path: "/categorylist" },
                { name: "Add HRA", path: "/add-hra" },
                { name: "Get All HRA", path: "/hralist" },
                { name: "All HRA Submitted List", path: "/hrasubmissionlist" },
                { name: "Question", path: "/question" },
                { name: "User Answers", path: "/answer" }
            ]
        },
        {
            name: "Blog",
            pages: [
                { name: "Add Blogs", path: "/createblog" },
                { name: "Get All Blogs", path: "/bloglist" }
            ]
        },
        {
            name: "Test",
            pages: [
                { name: "Create Test", path: "/createtest" },
                { name: "Get All Tests", path: "/testlist" },
                { name: "Create Diagnostic Tests", path: "/creatediagtest" },
                { name: "Get All Diagnostic Tests", path: "/diagtestlist" }
            ]
        },
        {
            name: "Scan & X-Ray",
            pages: [
                { name: "Create X-Rays", path: "/createxray" },
                { name: "Get All X-Rays", path: "/xraylist" }
            ]
        },
        {
            name: "Packages",
            pages: [
                { name: "Create Package", path: "/create-package" },
                { name: "Get All Packages", path: "/package-list" }
            ]
        },
        {
            name: "Medical Uploads",
            pages: [
                { name: "View Uploads", path: "/staffmedicaluplods" }
            ]
        },
        {
            name: "Employee",
            pages: [
                { name: "Add Employee", path: "/create-employee" },
                { name: "Employee List", path: "/employeelist" }
            ]
        },
        {
            name: "Banners",
            pages: [
                { name: "Add Banner", path: "/banner" }
            ]
        },
        {
            name: "Customer Support Tickets",
            pages: [
                { name: "All Tickets", path: "/raisedtickets" }
            ]
        },
        {
            name: "Settings",
            pages: [
                { name: "Settings", path: "/setting" }
            ]
        }
    ];

    const toggleSection = (sectionName) => {
        setOpenSections(prev => ({ ...prev, [sectionName]: !prev[sectionName] }));
    };

    const handlePageCheckbox = (path, isChecked) => {
        if (isChecked) {
            setSelectedPages(prev => [...prev, path]);
        } else {
            setSelectedPages(prev => prev.filter(p => p !== path));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        const employeeData = {
            name,
            email,
            password,
            mobile,
            address,
            gender,
            designation,
            department,
            employeeId,
            grade,
            pagesAccess: selectedPages,
        };

        try {
            const response = await axios.post('https://api.elthiumhealth.com/api/admin/create-employee', employeeData);
            if (response.status === 201) {
                alert('Employee created successfully!');
                navigate('/employeelist');
            }
        } catch (err) {
            setError('Failed to create employee. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-md mt-10">
            <h2 className="text-2xl font-semibold text-center mb-6">Create Employee</h2>

            <form onSubmit={handleSubmit}>
                {/* Name and Email */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div>
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700">Name</label>
                        <input type="text" id="name" className="mt-1 p-2 w-full border border-gray-300 rounded-md" value={name} onChange={(e) => setName(e.target.value)} required />
                    </div>
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
                        <input type="email" id="email" className="mt-1 p-2 w-full border border-gray-300 rounded-md" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="off" />
                    </div>
                </div>

                {/* Password and Mobile */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div>
                        <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
                        <input type="password" id="password" className="mt-1 p-2 w-full border border-gray-300 rounded-md" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="new-password" />
                    </div>
                    <div>
                        <label htmlFor="mobile" className="block text-sm font-medium text-gray-700">Mobile Number</label>
                        <input type="text" id="mobile" className="mt-1 p-2 w-full border border-gray-300 rounded-md" value={mobile} onChange={(e) => setMobile(e.target.value)} required />
                    </div>
                </div>

                {/* Address */}
                <div className="mb-4">
                    <label htmlFor="address" className="block text-sm font-medium text-gray-700">Address/Location</label>
                    <textarea id="address" className="mt-1 p-2 w-full border border-gray-300 rounded-md" value={address} onChange={(e) => setAddress(e.target.value)} required />
                </div>

                {/* Gender */}
                <div className="mb-4">
                    <label htmlFor="gender" className="block text-sm font-medium text-gray-700">Gender</label>
                    <select id="gender" className="mt-1 p-2 w-full border border-gray-300 rounded-md" value={gender} onChange={(e) => setGender(e.target.value)} required>
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                    </select>
                </div>

                {/* Designation, Department, Employee ID */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                    <div>
                        <label htmlFor="designation" className="block text-sm font-medium text-gray-700">Designation</label>
                        <input type="text" id="designation" className="mt-1 p-2 w-full border border-gray-300 rounded-md" value={designation} onChange={(e) => setDesignation(e.target.value)} required />
                    </div>
                    <div>
                        <label htmlFor="department" className="block text-sm font-medium text-gray-700">Department</label>
                        <input type="text" id="department" className="mt-1 p-2 w-full border border-gray-300 rounded-md" value={department} onChange={(e) => setDepartment(e.target.value)} required />
                    </div>
                    <div>
                        <label htmlFor="employeeId" className="block text-sm font-medium text-gray-700">Employee ID</label>
                        <input type="text" id="employeeId" className="mt-1 p-2 w-full border border-gray-300 rounded-md" value={employeeId} onChange={(e) => setEmployeeId(e.target.value)} required />
                    </div>
                </div>

                {/* Grade */}
                <div className="mb-4">
                    <label htmlFor="grade" className="block text-sm font-medium text-gray-700">Grade</label>
                    <select id="grade" className="mt-1 p-2 w-full border border-gray-300 rounded-md" value={grade} onChange={(e) => setGrade(Number(e.target.value))}>
                        <option value={1}>1</option>
                        <option value={2}>2</option>
                        <option value={3}>3</option>
                        <option value={4}>4</option>
                        <option value={5}>5</option>
                    </select>
                </div>

                {/* Page Access – Hierarchical Sections */}
                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Page Access</label>
                    <div className="border border-gray-300 rounded-md p-3 max-h-80 overflow-y-auto">
                        {menuSections.map((section, idx) => (
                            <div key={idx} className="mb-2">
                                <button
                                    type="button"
                                    className="flex justify-between items-center w-full text-left font-semibold text-gray-800 bg-gray-100 px-3 py-2 rounded-md hover:bg-gray-200"
                                    onClick={() => toggleSection(section.name)}
                                >
                                    <span>{section.name}</span>
                                    <span>{openSections[section.name] ? "▼" : "▶"}</span>
                                </button>
                                {openSections[section.name] && (
                                    <div className="ml-4 mt-1 space-y-1">
                                        {section.pages.map((page, pIdx) => (
                                            <label key={pIdx} className="flex items-center space-x-2 text-sm text-gray-700 cursor-pointer">
                                                <input
                                                    type="checkbox"
                                                    className="rounded border-gray-300"
                                                    checked={selectedPages.includes(page.path)}
                                                    onChange={(e) => handlePageCheckbox(page.path, e.target.checked)}
                                                />
                                                <span>{page.name}</span>
                                            </label>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                    <p className="text-sm text-gray-500 mt-1">Click on a category to expand and select pages.</p>
                </div>

                {/* Selected pages summary */}
                {selectedPages.length > 0 && (
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-2">Selected Pages:</label>
                        <div className="flex flex-wrap gap-2">
                            {selectedPages.map((path, index) => {
                                // Find page name from menuSections
                                let pageName = path;
                                for (let section of menuSections) {
                                    const found = section.pages.find(p => p.path === path);
                                    if (found) {
                                        pageName = found.name;
                                        break;
                                    }
                                }
                                return (
                                    <div key={index} className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full flex items-center text-sm">
                                        {pageName}
                                        <button
                                            type="button"
                                            className="ml-2 text-blue-600 hover:text-blue-800"
                                            onClick={() => handlePageCheckbox(path, false)}
                                        >
                                            ×
                                        </button>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}

                {/* Error message */}
                {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

                {/* Submit Button */}
                <button
                    type="submit"
                    className="w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-600 transition-colors"
                    disabled={loading}
                >
                    {loading ? 'Saving...' : 'Save Employee'}
                </button>
            </form>
        </div>
    );
}

export default CreateEmployee;